<template>
  <section id="admin-filter">
    <h4>Data Option filter</h4>
    <div class="form-group">
      <label for="filter-do-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="filter-do-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="filter-do-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="filter-do-name" v-model="entity.name"/>
    </div>
    <div class="form-group">
      <label for="filter-do-t" class="form-label">Option Type</label>
      <select class="form-control" id="filter-do-t" v-model="entity.optionType">
        <option value=""></option>
        <option v-for="(opt, i) in optionTypes" :value="opt.code">{{ opt.name }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'DataOptionFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          code: '',
          name: '',
          optionType: ''
        }
      }
    },
    computed: {
      optionTypes () {
        return this.$store.getters['systemOption/optionTypes']
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/DataOption/DataOptionFilter.vue